import React from "react";
import { Paper, Grid, Card, Typography } from "@mui/material";
import classes from "./ShelterDescription.module.css";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import List from "@mui/material/List";
import { green } from "@mui/material/colors";

import Capacity from "./Capacity/Capacity";
import PriceTable from "./PriceTable/PriceTable";
import ServiceList from "./ServiceList/ServiceList";
import OpeningHours from "./OpeningHours/OpeningHours";
import RulesCard from "./RulesCard/RulesCard";
import ImageCard from "./ImageCard/ImageCard";

function ShelterDescription({ shelterObj }) {
  const {
    capacity,
    priceList,
    images,
    name,
    street,
    locationSrc,
    services,
    openingHours,
    rules,
    city,
    usedCapacity,
    contact,
  } = shelterObj;
  return (
    <Paper elevation={3} className={classes.paper}>
      <List>
        <ListItem>
          <Typography component="div" variant="h2" sx={{ fontWeight: 500 }}>
            {name}
          </Typography>
        </ListItem>
        <List>
          <ListItem sx={{ ml: 2 }}>
            <ListItemAvatar>
              <Avatar sx={{ bgcolor: "#1a744d" }}>
                <LocationOnIcon />
              </Avatar>
            </ListItemAvatar>
            <Typography
              component="div"
              variant="h3"
              className={classes.paperHeading}
              sx={{ fontWeight: 300 }}
            >
              {street}, {city}
            </Typography>
          </ListItem>
          <ListItem sx={{ ml: 2 }}>
            <ListItemAvatar>
              <Avatar sx={{ bgcolor: "#1a744d" }}>
                <PhoneIcon />
              </Avatar>
            </ListItemAvatar>
            <Typography
              component="div"
              variant="h3"
              className={classes.paperHeading}
              sx={{ fontWeight: 300 }}
            >
              {contact}
            </Typography>
          </ListItem>
        </List>
      </List>

      <Grid container justifyContent="space-between" sx={{ margin: "15px 0 " }}>
        <Grid item md={12} lg={6}>
          <ImageCard images={images} />
        </Grid>
        <Grid item md={12} lg={6}>
          <RulesCard rules={rules} />
        </Grid>
      </Grid>
      <Card
        sx={{
          boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
          padding: "30px",
          margin: "30px 0",
        }}
      >
        <Typography component="div" sx={{ fontSize: "3rem", fontWeight: 500, padding: "0 16px" }}>
          O nás
          <hr style={{ margin: "2px", color: "rgba(0,0,0,0.2)" }} />
        </Typography>
        <List>
          <Grid container>
            <Grid item md={12} lg={6}>
              <OpeningHours openingHours={openingHours} />
            </Grid>
            <Grid item md={12} lg={6}>
              <Capacity capacity={capacity} usedCapacity={usedCapacity} />
            </Grid>
          </Grid>
          <ServiceList services={services} />
          <PriceTable priceList={priceList} />
        </List>
      </Card>
      <Card
        sx={{
          boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
          padding: "10px",
        }}
      >
        <Grid item xs={12}>
          <iframe
            title="Shelter location"
            src={locationSrc}
            style={{
              border: 0,
              boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
              margin: " 15px 0",
              width: "100%",
              height: "500px",
            }}
            allowfullscreen=""
            loading="lazy"
          ></iframe>
        </Grid>
      </Card>
    </Paper>
  );
}

export default ShelterDescription;
